/**
 * Token management utilities.
 *
 * Works alongside the React Router-based reauth pattern:
 * - location.state caches data for instant page loads
 * - ?reauth=true query param triggers cache invalidation
 * - /userProfile/reauth route handles token exchange with return path
 *
 * DO NOT replace the existing routing patterns with simple reloads!
 */

import { getJwtExpiry } from '@/lib/jwt'

export function getTokenDeadline(token: string): number {
    const exp = getJwtExpiry(token)
    if (exp === 0) {
        console.warn('Malformed JWT: missing or invalid exp claim')
    }
    return exp
}

export function calculateTimeUntilExpiration(expirationTime: number): number {
    return expirationTime - Date.now() / 1000
}
